import { chain } from 'lodash';

import { Nullable } from '~globals/types';
import { LogisticZoneType } from '~globals/types/enums';
import { LOGISTICS_ZONES_OPTIONS } from '~constants/logisiticZones';
import { LogisticZoneBase } from '~services/logisticsZones/types';

export const isLogisticTypeRange = (current: LogisticZoneType): boolean =>
  current === LogisticZoneType.Ranges;

export const isLogisticTypeGeometryArea = (
  current: LogisticZoneType,
): boolean => current === LogisticZoneType.GeometryArea;

export const getLabelTextForTypeLogisticZone = (
  logisticType: LogisticZoneType,
  typeLabel: 'normal' | 'short' = 'normal',
): Nullable<string> => {
  const keyLabel = typeLabel === 'short' ? 'labelShort' : 'label';

  return chain(LOGISTICS_ZONES_OPTIONS)
    .find({ value: String(logisticType) })
    .get(keyLabel, null)
    .value();
};

export const parseRangeDescriptionToArray = (
  rangeDescription: string,
): string[] => rangeDescription.split(',');

export const transformRangeDescriptionToText = (
  rangeDescription: string,
): string => {
  const zoneRangesArray = parseRangeDescriptionToArray(rangeDescription);

  return zoneRangesArray.join(' / ');
};

export const parseSelectedArrayRangeToString = (
  selectedRangeDescription: string[],
): string => selectedRangeDescription.join(',');

export const sortAlphabeticZoneByCode = (
  zones: LogisticZoneBase[],
): LogisticZoneBase[] =>
  [...zones].sort((a, b) => a.code.localeCompare(b.code));
